import React from 'react';
import { SectionLayout } from '@/components/section-layout';

export function BusinessInsightsPage() {
  return (
    <SectionLayout title="Business Insights">
      {/* Business insights content will go here */}
    </SectionLayout>
  );
} 